// export const frontendhost = "http://localhost:8000/";
// export const globalhosturl = "http://localhost:8000/";
// export const globalhostapi = "http://localhost:8000/api/";
export const frontendhost = "https://homes-bg.com/";
export const globalhosturl = "https://api.homes-bg.com/";
export const globalhostapi = "https://api.homes-bg.com/api/";
